"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ValueRoot = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _contactPickerTheme = require("../../contactPickerTheme");
const ValueRoot = (0, _styled.default)("div")`
    font-size: ${_ref => {
  let {
    themeMode
  } = _ref;
  return _contactPickerTheme.contactPickerTheme.selectedOption.fontSize(themeMode);
}};
    line-height: 18px;
    // To ensure overflow: ellipsis works, we need to provide the container with at least a
    // semblance of width.
    min-width: 1px;
`;
exports.ValueRoot = ValueRoot;
//# sourceMappingURL=ValueRoot.js.map